import { handleLocaleUrl, GLOBAL_CLIENT_ONLY_LOCALE } from 'dibs-intl/exports/urls';

export function redirectToOMT(transactionId: string): void {
    let url = '/orders/';
    if (transactionId) {
        url = url.concat(`order/${transactionId}`);
    }
    window.location.href = handleLocaleUrl(url, GLOBAL_CLIENT_ONLY_LOCALE);
}
